import {StyleSheet} from 'react-native';

export const seriesStyles = StyleSheet.create({
  // ── parent component helpers ─────────────────────────────────────
  loadingWrapper: {
    flex: 1,
    minHeight: 300,
    justifyContent: 'center',
    alignItems: 'center',
  },
  standardModalBody: {padding: 30, flex: 1},

  // ── modal header row ─────────────────────────────────────────────
  modalHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 24,
    paddingTop: 16,
    paddingBottom: 10,
  },
  modalCloseBtn: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: '#FAF6EB',
    alignItems: 'center',
    justifyContent: 'center',
  },

  // ── outer ticket wrapper ─────────────────────────────────────────
  ticket: {
    flex: 1,
    flexDirection: 'row',
    marginHorizontal: 20,
    marginBottom: 16,
    borderRadius: 18,
    borderWidth: 1,
    borderColor: 'rgba(38,35,34,0.08)',
    overflow: 'hidden',
  },

  // ── left body ────────────────────────────────────────────────────
  ticketBody: {
    flex: 1,
    backgroundColor: '#FFFDF5',
    paddingTop: 16,
    paddingRight: 22,
    paddingBottom: 16,
    paddingLeft: 22,
  },
  brand: {
    paddingBottom: 12,
    borderBottomWidth: 1,
    borderStyle: 'dashed',
    borderBottomColor: 'rgba(77,63,55,0.22)',
    marginBottom: 12,
    position: 'relative',
    overflow: 'hidden',
  },
  desktopCheckerWrap: {
    position: 'absolute',
    right: -12,
    top: -12,
    opacity: 0.35,
  },
  eyebrow: {
    fontSize: 11,
    letterSpacing: 0.88,
    fontWeight: '700' as const,
  },
  seriesName: {
    fontSize: 44,
    lineHeight: 44,
    marginTop: 4,
    marginBottom: 4,
    letterSpacing: -0.44,
  },
  tagline: {
    lineHeight: 19,
  },
  details: {
    gap: 12,
  },
  detailRow: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 34,
    gap: 12,
  },
  detailTexts: {
    flex: 1,
  },
  detailLabel: {
    fontSize: 11,
    letterSpacing: 0.66,
    color: '#888280',
    textTransform: 'uppercase',
    fontWeight: '600' as const,
  },

  // ── perforation ─────────────────────────────────────────────────
  perf: {
    width: 36,
    position: 'relative',
    overflow: 'visible',
  },
  perfLine: {
    position: 'absolute',
    left: 17,
    top: 8,
    bottom: 8,
    width: 0,
    borderLeftWidth: 2,
    borderStyle: 'dashed',
    borderLeftColor: 'rgba(77,63,55,0.28)',
  },
  notchTop: {
    position: 'absolute',
    left: 6,
    top: -12,
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: 'rgba(38,35,34,0.08)',
    zIndex: 2,
  },
  notchBot: {
    position: 'absolute',
    left: 6,
    bottom: -12,
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: 'rgba(38,35,34,0.08)',
    zIndex: 2,
  },

  // ── stub (right panel) ───────────────────────────────────────────
  stub: {
    flex: 1,
    backgroundColor: '#FAF6EB',
    paddingTop: 16,
    paddingRight: 18,
    paddingBottom: 16,
    paddingLeft: 18,
    justifyContent: 'space-between',
  },
  stubLabel: {
    fontSize: 11,
    letterSpacing: 0.88,
    color: '#888280',
    textTransform: 'uppercase',
    fontWeight: '700' as const,
  },
  priceRow: {
    flexDirection: 'row',
    alignItems: 'baseline',
    gap: 2,
    marginTop: 4,
  },
  rupee: {
    fontSize: 28,
    lineHeight: 28,
  },
  amount: {
    fontSize: 52,
    lineHeight: 46.8,
    letterSpacing: -1.04,
  },
  strikePrice: {
    fontSize: 28,
    textDecorationLine: 'line-through',
    marginTop: 2,
  },
  stubMeta: {
    fontSize: 12,
    marginTop: 2,
  },

  // ── includes list ────────────────────────────────────────────────
  includes: {
    borderTopWidth: 1,
    borderStyle: 'dashed',
    borderTopColor: 'rgba(77,63,55,0.22)',
    paddingTop: 14,
    marginTop: 16,
    gap: 8,
    marginBottom: 18,
  },
  includeRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  includeText: {
    flex: 1,
  },

  // ── CTA block ────────────────────────────────────────────────────
  ctaWrap: {
    marginTop: 18,
    gap: 8,
  },
  ctaBtn: {
    backgroundColor: '#FACF47',
    borderRadius: 32,
    paddingVertical: 14,
    paddingHorizontal: 18,
    alignItems: 'center',
  },
  ctaBtnDisabled: {
    opacity: 0.55,
  },
  ctaBtnText: {
    fontSize: 15,
    color: '#262322',
    fontWeight: '600',
  },
  ctaGhost: {
    borderRadius: 32,
    borderWidth: 1.5,
    borderColor: 'rgba(77,63,55,0.18)',
    paddingVertical: 12,
    paddingHorizontal: 16,
    alignItems: 'center',
  },
  ctaGhostText: {
    fontSize: 13,
    fontWeight: '600',
    color: '#262322',
  },
  trust: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 14,
    marginTop: 8,
  },
  trustItem: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  trustText: {
    fontSize: 11,
    color: '#888280',
  },
  errorMsg: {
    marginBottom: 4,
  },

  // ── skeleton ─────────────────────────────────────────────────────
  skeletonNameGap: {
    marginTop: 8,
    marginBottom: 8,
  },
  skeletonPriceGap: {
    marginTop: 6,
    marginBottom: 4,
  },

  // ── mobile bottom sheet ──────────────────────────────────────────
  mobileSheet: {
    flex: 1,
    backgroundColor: '#FFFFFF',
    paddingHorizontal: 20,
  },
  dragHandleRow: {
    alignItems: 'center',
    paddingTop: 12,
    paddingBottom: 0,
  },
  dragHandle: {
    width: 44,
    height: 4,
    borderRadius: 999,
    backgroundColor: 'rgba(77,63,55,0.25)',
    marginBottom: 12,
  },
  mobileScroll: {
    flex: 1,
  },
  mobileHero: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 16,
    borderRadius: 16,
    marginBottom: 0,
    position: 'relative',
    overflow: 'hidden',
  },
  mobileCheckerWrap: {
    position: 'absolute',
    right: -10,
    top: -10,
    opacity: 0.4,
  },
  mobileHeroIcon: {
    width: 64,
    height: 64,
    borderRadius: 12,
    backgroundColor: 'rgba(128,98,52,0.08)',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 14,
  },
  mobileHeroText: {
    flex: 1,
  },
  mobileEyebrow: {
    fontSize: 10,
    fontWeight: '700' as const,
    letterSpacing: 0.8,
  },
  mobileSeriesName: {
    fontSize: 32,
    lineHeight: 32,
    marginTop: 2,
    marginBottom: 4,
  },
  mobileSub: {
    fontSize: 12,
    lineHeight: 16,
  },
  metaGrid: {
    flexDirection: 'row',
    gap: 8,
    marginTop: 14,
  },
  metaTile: {
    flex: 1,
    backgroundColor: '#FAF6EB',
    borderRadius: 12,
    padding: 10,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    minHeight: 66,
  },
  metaTileText: {
    flex: 1,
  },
  metaTileLabel: {
    fontSize: 10,
    fontWeight: '600' as const,
    letterSpacing: 0.5,
    color: '#888280',
  },
  metaTileValue: {
    fontSize: 11,
    fontWeight: '600' as const,
    lineHeight: 14,
    marginTop: 1,
  },
  mobileIncludes: {
    marginTop: 14,
    marginBottom: 12,
    gap: 10,
  },
  mobileRoster: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FAF6EB',
    borderRadius: 12,
    paddingVertical: 10,
    paddingHorizontal: 12,
    marginBottom: 12,
  },
  mobileRosterText: {
    marginLeft: 8,
  },
  mobileScrollPad: {
    height: 100,
  },
  mobilePayBar: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: 14,
    borderTopWidth: 1,
    borderTopColor: 'rgba(77,63,55,0.10)',
  },
  mobilePayStrike: {
    fontSize: 11,
    textDecorationLine: 'line-through',
  },
  mobilePayAmountRow: {
    flexDirection: 'row',
    alignItems: 'baseline',
    gap: 1,
  },
  mobileRupee: {
    fontSize: 22,
    lineHeight: 22,
    letterSpacing: -0.38,
  },
  mobilePayAmount: {
    fontSize: 38,
    lineHeight: 38,
    letterSpacing: -0.38,
  },
  mobilePayMeta: {
    fontSize: 10,
    marginTop: 2,
  },
  mobileCta: {
    width: 200,
    backgroundColor: '#FACF47',
    borderRadius: 32,
    paddingVertical: 16,
    paddingHorizontal: 16,
    alignItems: 'center',
    justifyContent: 'center',
  },
  mobileCtaText: {
    fontSize: 15,
    fontWeight: '700' as const,
    color: '#262322',
  },
  mobileErrorMsg: {
    textAlign: 'center',
    marginTop: 6,
  },
  mobileTrustRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    marginTop: 10,
  },
  mobileTrustText: {
    fontSize: 10,
    color: '#888280',
  },
});
